import ApiService from "../common/apiService";

import { GET_INVOICES } from "./actions.type";
import {formatDate, formatAmount} from "../common/formatting";
import constants from "../common/constants";


const InvoicesModule = {
  state:{
    errors: null,
    invoices:{
      outstandingInvoices:{},
      paidInvoices:{}
    },
  },
  mutations:{
    storeInvoices(state,data){
      let invoices = [];
      invoices['outstandingInvoices'] = [];
      invoices['paidInvoices'] = [];
      if (data.hasOwnProperty('outstanding')) {
        for (let facility of data.outstanding) {
          for (let invoice of facility) {
            let newInvoice = {
              invoice_id :{
                value: invoice.transaction_number
              },
              type:{
                value:invoice.transaction_type
              },
              dueBy: {
                value: formatDate(invoice.transaction_date, constants.DD_MM_YYYY),
                realValue: invoice.transaction_date
              },
              facility_name:{
                value: invoice.facility.facility_number + ' - ' + invoice.facility.name
              },
              job_number: {
                value: invoice.job_number
              },
              amount_due: {
                value: invoice.amount < 0?'-$' + (''+invoice.amount).replace('-',''):'$' + invoice.amount
              },
            }
            invoices['outstandingInvoices'].push(newInvoice);
          };
        }
      }
      if (data.hasOwnProperty('paid')) {
        for (let facility of data.paid) {
          for (let invoice of facility) {
            let newInvoice = {
              invoice_id : {
                value: invoice.transaction_number
              },
              type:{
                value:invoice.transaction_type
              },
              paidOn: {
                value: formatDate(invoice.transaction_date),
                realValue: invoice.transaction_date
              },
              facility_name:{
                value: invoice.facility.facility_number + ' - ' + invoice.facility.name
              },
              job_number: {
                value: invoice.job_number
              },
              amount_due: {
                value: '$0'
              },
            };
            invoices['paidInvoices'].push(newInvoice);
          }
        };
      }
      state.invoices.outstandingInvoices = invoices['outstandingInvoices'];
      state.invoices.paidInvoices = invoices['paidInvoices'];
    }
  },
  actions:{
    [GET_INVOICES](context,payload){
      return ApiService.get('/invoices?current_role='+payload)
        .then(({data}) => {
          this.commit('storeInvoices', data);
          return this.state.invoices;
        })
        .catch(error => {
          return error
        });
    }
  }
};


export default InvoicesModule;
